export default __webpack_public_path__ + "static/media/Matt.a4f6dd35.png";